module.exports = __webpack_public_path__ + "assets/check.fbb2cd0f.svg";